export function mapLocale(lang?: string): string {
  const l = lang || 'en';
  return l.startsWith('hu') ? 'hu-HU' : 'en-US';
}

export function formatAmountWithCode(
  value: number | null | undefined,
  currencyCode?: string | null,
  lang?: string
): string {
  const numeric =
    value == null || Number.isNaN(value as any) ? 0 : Number(value);
  const amount = new Intl.NumberFormat(mapLocale(lang), {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(numeric);

  const code = (currencyCode ?? '').trim().toUpperCase() || '-';
  return `${amount} ${code}`;
}
